<div
  class="hug-passage-para"
  [innerHTML]="renderedParagraph"
  (click)="handleWordClick($event)"
></div>
